import api from "./base-api"

const tohFlaggedPlayersApi = api.injectEndpoints({
    endpoints: (build) => ({
        getFlaggedPlayersTOH: build.query({
            query: ({ page = 0, pageSize = 25, from, to, playerId, severity }) => {
                const p = new URLSearchParams({ page, size: pageSize, sort: "createdAt,desc" })
                if (from) p.set("from", from)
                if (to) p.set("to", to)
                if (playerId && playerId.trim()) p.set("playerId", playerId.trim())
                if (severity != null) p.set("severity", severity)
                return `v2/toh/flagged-players?${p.toString()}`
            },
            providesTags: ["TohFlaggedPlayers"]
        })
    }),
    overrideExisting: false
})

export const {
    useGetFlaggedPlayersTOHQuery
} = tohFlaggedPlayersApi
